import { ref, onMounted, onUnmounted, getCurrentInstance } from 'vue';

export function useInternetConnection() {
  const isOnline = ref(navigator.onLine);

  const updateOnlineStatus = () => {
    isOnline.value = navigator.onLine;
  };

  // Only use lifecycle hooks if we're inside a component context
  const instance = getCurrentInstance();

  if (instance) {
    onMounted(() => {
      window.addEventListener('online', updateOnlineStatus);
      window.addEventListener('offline', updateOnlineStatus);
    });

    onUnmounted(() => {
      window.removeEventListener('online', updateOnlineStatus);
      window.removeEventListener('offline', updateOnlineStatus);
    });
  } else {
    // Fallback: directly add listeners if not in component context
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
  }

  return { isOnline };
}
